// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CalculateDrainagePatternInput } from "./CalculateDrainagePatternInput";
import {
  CalculateDrainagePatternInputFromJSON,
  CalculateDrainagePatternInputFromJSONTyped,
  CalculateDrainagePatternInputToJSON,
  CalculateDrainagePatternInputToJSONTyped,
} from "./CalculateDrainagePatternInput";
import type { CalculateDrainagePatternOutput } from "./CalculateDrainagePatternOutput";
import {
  CalculateDrainagePatternOutputFromJSON,
  CalculateDrainagePatternOutputFromJSONTyped,
  CalculateDrainagePatternOutputToJSON,
  CalculateDrainagePatternOutputToJSONTyped,
} from "./CalculateDrainagePatternOutput";

/**
 *
 * @export
 * @interface CalculateDrainagePatternSchema
 */
export interface CalculateDrainagePatternSchema {
  /**
   *
   */
  tag: CalculateDrainagePatternSchemaTagEnum;
  /**
   *
   */
  inputs: CalculateDrainagePatternInput;
  /**
   *
   */
  outputs: CalculateDrainagePatternOutput;
}

/**
 * @export
 */
export const CalculateDrainagePatternSchemaTagEnum = {
  CalculateDrainagePattern: "calculate_drainage_pattern",
} as const;
export type CalculateDrainagePatternSchemaTagEnum =
  (typeof CalculateDrainagePatternSchemaTagEnum)[keyof typeof CalculateDrainagePatternSchemaTagEnum];

/**
 * Check if a given object implements the CalculateDrainagePatternSchema interface.
 */
export function instanceOfCalculateDrainagePatternSchema(
  value: object
): value is CalculateDrainagePatternSchema {
  if (!("tag" in value) || value["tag"] === undefined) return false;
  if (value["tag"] !== "calculate_drainage_pattern") return false;

  if (!("inputs" in value) || value["inputs"] === undefined) return false;
  if (!("outputs" in value) || value["outputs"] === undefined) return false;
  return true;
}

export function CalculateDrainagePatternSchemaFromJSON(json: any): CalculateDrainagePatternSchema {
  return CalculateDrainagePatternSchemaFromJSONTyped(json, false);
}

export function CalculateDrainagePatternSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CalculateDrainagePatternSchema {
  if (json == null) {
    return json;
  }
  return {
    tag: json["tag"],
    inputs: CalculateDrainagePatternInputFromJSON(json["inputs"]),
    outputs: CalculateDrainagePatternOutputFromJSON(json["outputs"]),
  };
}

export function CalculateDrainagePatternSchemaToJSON(json: any): CalculateDrainagePatternSchema {
  return CalculateDrainagePatternSchemaToJSONTyped(json, false);
}

export function CalculateDrainagePatternSchemaToJSONTyped(
  value?: CalculateDrainagePatternSchema | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tag: value["tag"],
    inputs: CalculateDrainagePatternInputToJSON(value["inputs"]),
    outputs: CalculateDrainagePatternOutputToJSON(value["outputs"]),
  };
}
